import { render, staticRenderFns } from "./genelamaclirapor.vue?vue&type=template&id=2a1f8b09&scoped=true"
import script from "./genelamaclirapor.vue?vue&type=script&lang=js"
export * from "./genelamaclirapor.vue?vue&type=script&lang=js"
import style0 from "./genelamaclirapor.vue?vue&type=style&index=0&id=2a1f8b09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f8b09",
  null
  
)

export default component.exports